// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"158":"0efe9039","227":"ee05c99a","480":"d158da6a","927":"5c4547e8"}[chunkId] + ".css";
};